"use strict";
import * as Pb from "../data/types/Pb";
import {
  carriesOcrLine,
  installOcrLineDragSource,
  readOcrLinePayload
} from "../ocr_line_drop";
function ocrDropZoneClass(componentFlags) {
  const flags = componentFlags.componentFlags;
  switch (flags.type) {
    case Pb.EmbeddedComponentsFlags_ComponentFlagsType.PODDefinition:
      return flags.pod_definition.ocr_drop_zone_class;
    default:
      return null;
  }
}
export function maybeSetupOcrTextDrop(componentFlags, container, elmApp) {
  const dropZoneClass = ocrDropZoneClass(componentFlags);
  if (!dropZoneClass || !container) {
    return null;
  }
  return setupOcrTextDrop(container, elmApp, dropZoneClass);
}
function setupOcrTextDrop(container, elmApp, dropZoneClass) {
  installOcrLineDragSource();
  const insideDropZone = (event) => event.target instanceof Element && event.target.closest(`.${dropZoneClass}`) !== null;
  const startDrag = (event) => {
    var _a, _b;
    if (carriesOcrLine(event.dataTransfer)) {
      (_b = (_a = elmApp.ports) == null ? void 0 : _a.ocrDragActive) == null ? void 0 : _b.send(true);
    }
  };
  const endDrag = () => {
    var _a, _b;
    return (_b = (_a = elmApp.ports) == null ? void 0 : _a.ocrDragActive) == null ? void 0 : _b.send(false);
  };
  const allowDrop = (event) => {
    if (carriesOcrLine(event.dataTransfer) && insideDropZone(event)) {
      event.preventDefault();
      if (event.dataTransfer) {
        event.dataTransfer.dropEffect = "copy";
      }
    }
  };
  const handleDrop = (event) => {
    var _a, _b, _c;
    if (!insideDropZone(event)) {
      return;
    }
    const payload = readOcrLinePayload(event.dataTransfer);
    if (!payload) {
      return;
    }
    event.preventDefault();
    (_c = (_a = elmApp.ports) == null ? void 0 : _a.ocrTextDropped) == null ? void 0 : _c.send((_b = payload.chars) != null ? _b : "");
  };
  document.addEventListener("dragstart", startDrag);
  document.addEventListener("dragend", endDrag, true);
  container.addEventListener("dragenter", allowDrop);
  container.addEventListener("dragover", allowDrop);
  container.addEventListener("drop", handleDrop);
  return () => {
    document.removeEventListener("dragstart", startDrag);
    document.removeEventListener("dragend", endDrag, true);
    container.removeEventListener("dragenter", allowDrop);
    container.removeEventListener("dragover", allowDrop);
    container.removeEventListener("drop", handleDrop);
  };
}
